import httpV2 from "@/utils/http_v2";
import Vue from "vue";
import Vuex from "vuex";
import cache from "@/utils/cache";



const state = {
    token: localStorage.getItem('token') || '',
    loading: true,

}
const getters = {
 
    getLoading: state =>{
        return state.loading
    }

}

const mutations = {
    /**
     * 设置进度条
     * @param state 
     * @param status 
     */
    setLoading(state, status) {
        state.loading = status
    },


}


const actions = {
    //oss签名
    // getSignature({
    //     state,
    //     commit
    // }, params) {
    //     let promise;

    //     promise = httpV2.get(
    //         process.env.NUXT_ENV.OSS_API + "/v1.0/system/oss/signature/anonymous",
    //         params,
    //         this
    //     );

    //     return promise;
    // },
}
export default {
    getters,
    state,
    mutations,
    actions
}